import React,{useRef,useState,useEffect,useContext} from 'react'
import { useNavigate } from 'react-router-dom'
import { UserContext } from './context/UserContext'
import axios from 'axios'
import Logo from './logo.png'
import Btn from './ui/Btn'
import './login.css'

/* Inline so the reveal control needs no icon package and inherits the
   token colour through `stroke: currentColor` (see login.css). */
const EyeIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M1.8 12S5.4 5.2 12 5.2 22.2 12 22.2 12 18.6 18.8 12 18.8 1.8 12 1.8 12Z" />
    <circle cx="12" cy="12" r="3.1" />
  </svg>
)

const EyeOffIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M9.9 5.5A9.9 9.9 0 0 1 12 5.2c6.6 0 10.2 6.8 10.2 6.8a18.6 18.6 0 0 1-3.3 4.3" />
    <path d="M6.4 6.5A18.4 18.4 0 0 0 1.8 12S5.4 18.8 12 18.8a9.9 9.9 0 0 0 4.1-.9" />
    <path d="M9.9 9.9a3.1 3.1 0 0 0 4.3 4.4" />
    <path d="M3.2 3.2 20.8 20.8" />
  </svg>
)

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/

export default function Login() {
  const {isAuth,setIsAuth}=useContext(UserContext)
  const {apiToken,setApiToken} = useContext(UserContext)
  const [loginError,setLoginError]=useState(false)
  const [loginSuccess,setLoginSuccess]=useState(false)
  const [msg,setMsg]=useState('')
  const [isLoading,setIsLoading]=useState(false)
  const [showPassword,setShowPassword]=useState(false)
  const [fieldErrors,setFieldErrors]=useState({email:'',password:''})
  const {userToken,setUserToken} = useContext(UserContext)
  const {userName,setUserName}=useContext(UserContext)
  const {usrPhoto,setUsrPhoto}=useContext(UserContext)
  const {socket,setSocket}=useContext(UserContext)
  const Email=useRef('')
  const Password=useRef('')

  const navigate=useNavigate ()

  useEffect(()=>{
    if (sessionStorage.getItem('Email')){
      sessionStorage.getItem('Email')
      sessionStorage.getItem('Password')
      login(sessionStorage.getItem('Email'),sessionStorage.getItem('Password'))
    }

  },[])




  const login=(Email,Password)=>{
    const loginObj={
      Email,
      Password
    }
    sessionStorage.removeItem('Email')
    sessionStorage.removeItem('Password')

    setIsLoading(true)

    axios.post(process.env.REACT_APP_API_SERVER+'manager/login',loginObj).then(res=>{
      if (res.data.err==0){
        //console.log(res.data.usr)
        setIsLoading(false)
        setIsAuth(true)
        setUserToken(res.data.usr.CustomerUUID)
        setUserName(res.data.usr.Name)
        setLoginSuccess(true)
        setLoginError(false)
        setApiToken(res.data.usr.token)

        setUsrPhoto(`${process.env.REACT_APP_API_SERVER}manager/profile/photo/${res.data.usr.CustomerUUID}/${Date.now()}`)
        sessionStorage.setItem('usrPhoto',`${process.env.REACT_APP_API_SERVER}manager/profile/photo/${res.data.usr.CustomerUUID}/${Date.now()}`)
        sessionStorage.setItem('isAuth',1)
        sessionStorage.setItem('userToken',res.data.usr.CustomerUUID)
        sessionStorage.setItem('userName',res.data.usr.Name)
        sessionStorage.setItem('mngapiToken',res.data.usr.token)
        sessionStorage.setItem('ProductTitle',res.data.usr.Title)
        sessionStorage.setItem('SportID',res.data.usr.SportID)
        sessionStorage.setItem('appCountries',JSON.stringify(res.data.usr.appCountries))
        sessionStorage.setItem('ChatUserUUID',res.data.usr.ChatUserUUID)

        if (res.data.usr.ChatUserUUID.length>0){
          socket.emit('user-connected',res.data.usr.ChatUserUUID)
        }



        setTimeout(() => {

          navigate('/dashboard')
      }, 3000);
      }else{
        setIsLoading(false)
        setIsAuth(false)
        // setUserToken(null)
        // setLoginSuccess(false)
        setMsg(res.data.msg)
        setLoginError(true)
        setTimeout(() => {
            setLoginError(false)
        }, 3000);
      }
    }).catch(()=>{
      // Transport failure only: the request, its payload and every
      // success/failure branch above are untouched. Without this the
      // button would stay in its pending state forever when the API
      // is unreachable.
      setIsLoading(false)
      setMsg('We could not sign you in. Please check your connection and try again.')
      setLoginError(true)
    })
  }

  const validate=()=>{
    const next={email:'',password:''}
    const emailValue=(Email.current && Email.current.value ? Email.current.value : '').trim()
    const passwordValue=(Password.current && Password.current.value) ? Password.current.value : ''

    if (!emailValue){
      next.email='Enter your email address.'
    }else if (!EMAIL_RE.test(emailValue)){
      next.email='That does not look like a valid email address.'
    }

    if (!passwordValue){
      next.password='Enter your password.'
    }

    return next
  }

  const clearFieldError=(field)=>{
    setFieldErrors(prev=> prev[field] ? {...prev,[field]:''} : prev)
  }

  const submit=(e)=>{
    e.preventDefault()

    const next=validate()
    setFieldErrors(next)

    if (next.email || next.password){
      const target=next.email ? Email.current : Password.current
      if (target) target.focus()
      return
    }

    setLoginError(false)
    setMsg('')

    login(Email.current.value,Password.current.value)

  }

  // Drop the global page padding while the login screen is mounted, and
  // let styles.css kill the horizontal scrollbar the full-bleed layout
  // would otherwise create.
  useEffect(() => {
    // add the "login-page" modifier to <html> and <body> on mount
    document.documentElement.classList.add('login-page');
    document.body.classList.add('login-page');

    return () => {
      // remove the "login-page" modifier again on unmount
      document.documentElement.classList.remove('login-page');
      document.body.classList.remove('login-page');
    };
  }, []);

  const busy = isLoading || loginSuccess

  return (

    <div
      className="login-stage bg-md-login"
      style={{
        '--login-bg': `url(${process.env.PUBLIC_URL}/mob-login.jpg)`,
        '--login-art': `url(${process.env.PUBLIC_URL}/burn-ball.jpg)`
      }}
    >
      <section className="login-art">
        <span className="login-art-rule" />
        <p className="login-art-eyebrow">onetwothreehigh.com</p>
        <p className="login-art-word">manager</p>
        <p className="login-art-tag">
          Built for coaches, admins, talent scouts and sports leaders &mdash; engineered for greatness.
        </p>
      </section>

      <main className="login-col">
        <div className="login-card">
          <img src={Logo} alt="123High" className="login-logo" />

          <p className="login-eyebrow">manager &middot; onetwothreehigh.com</p>
          <h1 className="login-title">Sign in</h1>
          <p className="login-tag-narrow">
            Built for coaches, admins, talent scouts and sports leaders &mdash; engineered for greatness.
          </p>

          <form onSubmit={submit} className="login-form" noValidate>
            <div className="login-field">
              <label className="login-label" htmlFor="inputEmail">Email address</label>
              <input
                id="inputEmail"
                type="email"
                placeholder="you@club.com"
                required
                ref={Email}
                autoFocus
                autoComplete="username"
                disabled={busy}
                aria-invalid={fieldErrors.email ? 'true' : 'false'}
                aria-describedby={fieldErrors.email ? 'inputEmailError' : undefined}
                onChange={()=>clearFieldError('email')}
                className={fieldErrors.email ? 'login-input login-input-bad' : 'login-input'}
              />
              {fieldErrors.email &&
                <p className="login-err" id="inputEmailError">{fieldErrors.email}</p>
              }
            </div>

            <div className="login-field">
              <label className="login-label" htmlFor="inputPassword">Password</label>
              <div className="login-pw">
                <input
                  id="inputPassword"
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Your password"
                  required
                  ref={Password}
                  autoComplete="current-password"
                  disabled={busy}
                  aria-invalid={fieldErrors.password ? 'true' : 'false'}
                  aria-describedby={fieldErrors.password ? 'inputPasswordError' : undefined}
                  onChange={()=>clearFieldError('password')}
                  className={fieldErrors.password ? 'login-input login-input-bad' : 'login-input'}
                />
                <button
                  type="button"
                  className="login-eye"
                  disabled={busy}
                  onClick={()=>setShowPassword(!showPassword)}
                  aria-pressed={showPassword}
                  aria-controls="inputPassword"
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                  title={showPassword ? 'Hide password' : 'Show password'}
                >
                  {showPassword ? <EyeOffIcon/> : <EyeIcon/>}
                </button>
              </div>
              {fieldErrors.password &&
                <p className="login-err" id="inputPasswordError">{fieldErrors.password}</p>
              }
            </div>

            <div className="login-actions">
              {loginSuccess &&
                <p className="login-note login-note-good" role="status" aria-live="polite">
                  <b>Signed in</b>
                  Welcome {userName}. Please wait...
                </p>
              }

              {loginError &&
                <p className="login-note login-note-bad" role="alert">
                  <b>Sign in failed</b>
                  {msg}
                </p>
              }

              <Btn
                variant="accent"
                type="submit"
                className="login-submit"
                disabled={busy}
              >
                {loginSuccess ? 'Signed in' : (isLoading ? 'Signing in...' : 'Login')}
              </Btn>
            </div>
          </form>

          <p className="login-foot">
            Trouble signing in? Contact your 123High account manager.
          </p>
        </div>
      </main>
    </div>

  )
}
